<script>
    import AdminList from '../_List';
    import TableRow from './_Row';

    export default {
        extends: AdminList,

        data: () => ({
            cols: ['Benutzer', 'Status', 'Berechtigung', ''],
            TableRow,
            removeRow: null,
            removeModal: null,
        }),
    };
</script>
